import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import withRestrictedAccess from '../../higherOrderComponents/withRestrictedAccess';
import IntegrationWrapper from '../../components/Resources/integrationNew/Integration/Integration';
import { useSelector } from 'react-redux';
import { selectUserInfo } from '../../store/selectors/userInfo';

const Integration = (props) => {
  const isCompletedLoadingUserInfo = useSelector(selectUserInfo).status === 'COMPLETED';

  return isCompletedLoadingUserInfo ? (
    <div className='page-container'>
      <IntegrationWrapper {...props} />
    </div>
  ) : null;
};

const enhance = compose(
  injectIntl,
  withRouter,
  connect((state) => state),
  withRestrictedAccess
);

export default enhance(Integration);
